<div class="modal-content modal-contents" *ngIf="!success">
  <div class="modal-header change-modal-header">
    <h5 class="modal-title text-teal">Add New Crop</h5>
    <button type="button" class="close" data-dismiss="modal">
      &times;
    </button>
  </div>
  <form  #createCropForm="ngForm" class="px-2 py-2" id="cropForm">
    <div class="modal-body">
      <div class="form-row">
        <div class="form-group col-md-12">
          <label>Crops</label>
          <input type="text" class="form-control" name="crops" ngModel #crops="ngModel" required
            pattern="^([a-zA-Z,\s\-\(\)]*)$" />
          <div *ngIf="crops.touched && !crops.valid" class="error_message">
            <span class="text-danger" *ngIf="crops.errors.required">
              Please enter crops.
            </span>
            <span *ngIf="crops.errors.pattern" class="text-danger">Only alphabetic characters separated with a comma are
              allowed.</span>
          </div>
        </div>
        <div class="form-group col-md-12">
          <label>Image</label>
          <input
          type="file"
          class="form-control"
          id="cropPhoto"
          name="photo"
          #photo="ngModel"
          [(ngModel)]="model.photo"
          (change)="processImage($event)"
          accept="image/*"
        />
        <div
          *ngIf="photo.touched && !photo.valid || requiredField.photo"
          class="error_message"
        >
          Please the crop image should be of format(jpeg, jpg or png)  and 2MB allowed. 
        </div>
        </div>
      </div>
    </div>
    <div class="error_message" *ngIf="db_errors">
      <span class="text-danger">{{ db_errors }}</span>
    </div>
    <div class="d-flex justify-content-center align-item-center form-group">
      <button type="button" (click)="createCrop(createCropForm.value)" class="submit-crop-btn" [disabled]="!createCropForm.form.valid">
        <span *ngIf="loading" class="spinner-border spinner-border-md text-white" role="status"></span>
        <span *ngIf="loading" class="mx-2">Loading...</span>
        <span *ngIf="!loading">
          Add Crop
        </span>
      </button>
    </div>
  </form>
</div>
